export const verifyTemplateGenerator = (props) => ({
  title: 'Confirm your data',
  sections: [
    {
      type: !!props.title ? 'card_heading' : 'khali_section',
      content: {
        title: props.title,
      },
      tables: [
        {
          tableKey: props.tableKey,
          enableAddRow: true,
          enableMultipleSelect: true,
          tableActions: [
            {
              iconId: 1,
              name: 'Save',
              apiType: 2,
              deep_link: props.submitDeeplink,
            },
          ],
          aggregateActions: [
            {
              iconId: 1,
              name: 'Save Selected',
              apiType: 2,
              deep_link: props.submitDeeplink,
            },
          ],
          columns: props.columns.map((column) => ({
            title: column.title,
            key: column.key,
            isEditable: true,
            columnContentType: column.columnContentType || {
              columnType: 2,
              dataType: 0,
            },
            selection: column.selection || [],
            options: column.options || [],
          })),
          rows: props.rows,
        },
      ],
    },
  ],
});

export const multiSheetVerifyTable = (props) => {
  return {
    title: 'Confirm your data',
    buttons: [
      {
        iconId: 1,
        title: 'Save',
        apiType: 2,
        deep_link: props.submitDeeplink,
      },
    ],
    tabFormKey: props.bodyKey,
    tabCards: [
      ...(props.sheetNames.map((sheetName) => ({
        title: sheetName,
        card: {
          card_id: 'WOSUM_user35c91ac4-ec44-11ea-bae0-8afb9f63baed',
          card_type: 'one_card_with_gradient',
          content: [
            {
              card_content_type: 'card_105',
              title: (props.sheets[sheetName] || []).length,
              gradientId: 1,
              iconId: 145,
              subtitle: sheetName,
            },
          ],
        },
        tabContent: {
          sections: [
            {
              type: !'khali_section',
              content: {},
              tables: [
                {
                  tableKey: props.tableKey,
                  enableAddRow: true,
                  enableMultipleSelect: true,
                  columns: props.columns.map((column) => ({
                    title: column.title,
                    key: column.key,
                    isEditable: true,
                    columnContentType: column.columnContentType || {
                      columnType: 2,
                      dataType: 0,
                    },
                    selection: column.selection || [],
                    options: column.options || [],
                  })),
                  rows: (props.sheets || {})[sheetName].map(
                    (currentRow, index) => ({
                      id: index,
                      ...(props.columns
                        .filter((column) => !column.skipMapping)
                        .reduce((row, column) => {
                          return {
                            ...row,
                            [column.key]: {
                              value:
                                currentRow[
                                  (props.sheetColumnMap[sheetName] || {})[
                                    column.key
                                  ]
                                ],
                              cellEditable: true,
                            },
                          };
                        }, {}) || {}),
                    })
                  ),
                },
              ],
            },
          ],
        },
      })) || []),
    ],
  };
};
